/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Entity_LeadInputs */

const cs_enum_entity_lead = /** @type {(inputs: Enum_Entity_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lead`)
};

const en_enum_entity_lead = /** @type {(inputs: Enum_Entity_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lead`)
};

/**
* | output |
* | --- |
* | "Lead" |
*
* @param {Enum_Entity_LeadInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_entity_lead = /** @type {((inputs?: Enum_Entity_LeadInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Entity_LeadInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_entity_lead(inputs)
	return cs_enum_entity_lead(inputs)
});